<template>

  <div>
    <h2><i class="fa fa-question">&nbsp;</i><org-badge /> Help</h2>
    <el-row v-if="isDesktop || isTablet" type="flex" justify="center" align="middle">

      <el-col>
        <select-input v-model="menu" :list="lang" placeholder="Select Language..." @change="getManual" no-form />
      </el-col>

      <el-col align="right">
        <p>Problems with the system? <a href="https://support.xolas.io" target="_blank">support.xolas.io</a></p>
      </el-col>

    </el-row>

     <component :is="comp" />

    <el-row type="flex" justify="center" align="middle">
      <el-col align="center">
        <p><b>Version {{ver}}</b>&nbsp;For {{clientName}}</p>
      </el-col>
    </el-row>


  </div>

</template>

<script>

import {VERSION} from '@/components/Data'

import ArrayMixins from '@/mixins/ArrayMixins'

import HelpEnglish from '@/components/about/HelpEnglish'
import HelpBahasaMalaysia from '@/components/about/HelpBahasaMalaysia'

export default {

  mixins: [ArrayMixins],

  components: {
    HelpEnglish,
    HelpBahasaMalaysia
  },


  computed: {
    logo () { return this.xolasClient().logoPath },
    clientName () { return this.xolasClient().name }
  },

  methods: {
    getManual (item) {
      let ind = this.findInList('value', item, this.lang)
      this.comp = ind.comp
    }
  },

  data () {
    return {
      ver: VERSION,

      menu: 'EN',
      comp: HelpEnglish,

      lang: [
        {value: 'EN', label: 'English', image: 'static/flags/uk.png', comp: HelpEnglish},
        {value: 'MS', label: 'Bahasa Malaysia', image: 'static/flags/my.png', comp: HelpBahasaMalaysia}
      ]
    }
  }

}

</script>
